export const isNotNullOrWhitespace = (value) => !!value && value.replace(/\s/g, "").length > 0;

export const matchesTerm = (value, term) => `${value}`.toLowerCase().includes(`${term}`.toLowerCase());

export default { isNotNullOrWhitespace, matchesTerm };
